import onInit from "../utils/onInit";
import toggleBackdrop from "../utils/toggleBackdrop";

onInit(() => {
  const els = [
    document.getElementById('a-side-menu-btn'),
    document.getElementById('a-side-menu-close')
  ];

  Array.prototype.forEach.call(els, (el) => {
    el.addEventListener('click', function () {
      toggleBackdrop();
      document.getElementById('a-side-menu').classList.toggle('is-active');
      document.body.classList.toggle('body-locked')
      Array.prototype.forEach.call(els, (itemEl) => itemEl.classList.toggle('is-active'))
    });
  })

  Array.prototype.forEach.call(document.querySelectorAll('#a-side-menu a.dropdown-toggle'), function (el) {
    el.addEventListener('click', function (e) {
      if (e.target.classList.contains('dropdown-expand')) {
        e.preventDefault();
        e.target.classList.toggle('is-active');
        el.parentElement.querySelector('ul.dropdown-menu').classList.toggle('is-active')
      }
    });
  });
})
